import React from 'react'

const Manual_config_tiempos_comida = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Configuraciones - Tiempos de Comida
        </h2>
        <iframe
          src="https://scribehow.com/embed/Configuraciones__Tiempos_de_Comida__MtBfKeTiT8-H_QboJsLIAA?as=scrollable"
          className="scribe-iframe-general-160"
          width="100%"
          height="3600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_config_tiempos_comida
